import React from "react";
import { useMediaQuery } from "react-responsive";
import SectionHeading from "./sectionHeading";
import SolutionsList from "./solutionsList";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function SurveySection({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  return (
    <div className={"surveySection-root"}>
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className={`surveySection ${isMobile ? "mobile" : "desktop"}`}>
        {!!content?.isImageRight && (
          <>
            <div className="left">
              <div className="solutionsSection">
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: isMobile ? content.descriptionMobile : content.description }}
                />
                {!!isMobile && (
                  <div className={"right"}>
                    <LazyLoadImage src={content.image?.url} alt="vaccine" effect="blur" />
                  </div>
                )}
                <div className="listTitle" dangerouslySetInnerHTML={{ __html: content.listTitle }} />
                <SolutionsList list={content.list} />
                <div
                  className="solutionsDescription"
                  dangerouslySetInnerHTML={{ __html: isMobile ? content.bottomLineMobile : content.bottomLine }}
                />
                {content.buttonText && (
                  <a href={content.buttonLink} className="linkPrimary sm">
                    <div dangerouslySetInnerHTML={{ __html: content.buttonText }} />
                  </a>
                )}
              </div>
            </div>
            {!isMobile && (
              <div className={"right"}>
                <LazyLoadImage src={content.image?.url} alt="vaccine" effect="blur" />
              </div>
            )}
          </>
        )}
        {!content?.isImageRight && (
          <>
            {!isMobile && (
              <div className={"left"}>
                <LazyLoadImage src={content.image?.url} alt="vaccine" effect="blur" />
              </div>
            )}
            <div className="right">
              <div className="solutionsSection topdiv">
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: isMobile ? content.descriptionMobile : content.description }}
                />
                {!!isMobile && (
                  <div className={"right"}>
                    <LazyLoadImage src={content.image?.url} alt="vaccine" effect="blur" />
                  </div>
                )}
                <div className="listTitle" dangerouslySetInnerHTML={{ __html: content.listTitle }} />
                <SolutionsList list={content.list} />
                <div
                  className="solutionsDescription"
                  dangerouslySetInnerHTML={{ __html: isMobile ? content.bottomLineMobile : content.bottomLine }}
                />
                {content.buttonText && (
                  <a href={content.buttonLink} className="linkPrimary sm">
                    <div dangerouslySetInnerHTML={{ __html: content.buttonText }} />
                  </a>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
